<template>


    <div class="row" id="keywordList">
        <div class="col-md-12 mt20" v-if="! isAuthenticated">
            <div class="alert alert-danger">
                *This is dummy data please <a :href="routes.login">login</a> / <a :href="routes.register">register</a> to see real data.
            </div>
        </div>
        <!-- Start of Job Post Main -->
        <div class="col-md-12">

            <div class="panel panel-default">
                <div class="panel-heading" style="background: #E4E6EB; color: black; font-weight: 600;">{{ $_f.numberFormat(paginateTitle) }}
                    <span style="float:right;"><button type="button" :disabled="! isAuthenticated" v-if="download" @click="$emit('download')" class="btn bg-primary-dark text-white btn-small"><i class="fa fa-download"></i> <span class="hidden-xs hidden-sm">Download</span></button></span>
                </div>
                <div class="panel-body">
                    <div class="table-responsive scrollBarStyle" id="keywordTableResponsive">

                        <table class="table table-sm tblFixed" >
                            <tbody>
                            <template v-for="(v,i) in (isAuthenticated && isFree ? keywords?.data.slice(0,25) : keywords?.data)">
                                <tr>
                                    <td style="vertical-align: middle; width: 50%">
                                        <span :title="v.keyword" >
                                            <span style="font-weight: 800;" v-html="v.keyword_html"></span>
                                            <a title="View Trend" :href="v.trend_link" target="_blank" style="color: #2E5CE5; margin-left: 15px"><i class="fa fa-line-chart"></i></a>
                                        </span>
                                        <div>
                                            <span title="Country" class="small badge badge-info bg-blue">{{ $_f.initCap(countryGroup[v.country.toLowerCase()] || v.country) }}</span>
                                            <span v-if="v.k_created_at" class="visible-xs-inline ml5 small badge badge-primary bg-green">Added On: {{ formatDate(v.k_created_at , "MMM DD, Y") }}</span>
                                            <span  v-if="v.k_updated_at" class="visible-xs-inline ml5 small badge badge-warning bg-orange">Updated On: {{ formatDate(v.k_updated_at , "MMM DD, Y") }}</span>
                                        </div>
                                        <div class="visible-md visible-lg">
                                            <span v-if="v.k_created_at" class="small badge badge-primary bg-green">Added On: {{ formatDate(v.k_created_at , "MMM DD, Y") }}</span>
                                            <span  v-if="v.k_updated_at" class="small badge ml5 badge-warning bg-orange">Updated On: {{ formatDate(v.k_updated_at , "MMM DD, Y") }}</span>
                                        </div>
                                        <div class="visible-xs">
                                            <DisplayKeywordSearches :colorful="true" :count="v.gw_count" :is-free="isFree" />
                                        </div>
                                        <div class="visible-xs" style="width: 300px !important;">
                                            <template v-if="v.graph" >
                                                <span class="cursor-pointer" @click="showGraph(v)">
                                                    <LineChart :data="{
                                                        datasets: [
                                                          {
                                                              label: v.keyword,
                                                              borderColor: '#2E5CE5',
                                                              borderWidth: 1.2,
                                                              tension: 0.3,
                                                              fill: false,
                                                              data: v.graph
                                                          }
                                                  ]}" :options="chartData.options"  style="display: block; width:320px; height: 100px;" />
                                                </span>
                                            </template>
                                            <template v-else>
                                                <div class="text-left pt15 pb10">
                                                    <span class="btnTrendPercentage"><i class="fa fa-bolt text-success"></i> {{ v.trend_percentage }}</span>
                                                    <a class="btnTrendLink" :href="v.trend_link" target="_blank">View Trend</a>
                                                </div>
                                            </template>
                                        </div>
                                    </td>


                                    <td class="visible-md visible-lg" style="vertical-align: middle; width: 15%">
                                        <DisplayKeywordSearches :count="v.gw_count" :is-free="isFree" />
                                    </td>
                                    <td class="visible-md visible-lg" style="width: 30%; vertical-align: middle;">
                                        <template v-if="v.graph" >
                                            <span class="cursor-pointer" @click="showGraph(v)">
                                                <LineChart :data="{
                                                     datasets: [
                                                          {
                                                              label: v.keyword,
                                                              borderColor: '#2E5CE5',
                                                              borderWidth: 1.5,
                                                              tension: 0.2,
                                                              fill: false,
                                                              data: v.graph
                                                          }
                                                      ]
                                                }" :options="chartData.options"  style="display: block; width: auto; height: 90px;" />
                                            </span>
                                        </template>
                                        <template v-else>
                                            <div class="text-right">
                                                <span class="btnTrendPercentage"><i class="fa fa-bolt text-success"></i> {{ v.trend_percentage }}</span>
                                                <a class="btnTrendLink" :href="v.trend_link" target="_blank">View Trend</a>
                                            </div>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <tr v-if="isAuthenticated & isFree">
                                <td colspan="3" style="vertical-align: middle; width: 100%">
                                    <div id="guest-jumbotron" class="jumbotron mb-0"><div class="text-center"><h2>
                                        Upgrade to view all the keywords
                                    </h2> <a href="javascript:void(0);" onclick="showUpgradeModal()" class="btn btn-success btn-lg signup-btn mt20">Upgrade Now</a></div></div>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="mb20" v-if="isAuthenticated && !isFree">
                            <PaginationUser   :data="keywords" @pagination-change-page="fetch" :limit="10"></PaginationUser>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Teleport to="body">
            <div class="cd-user-modal" id="graphModal" >
                <div class="cd-user-modal-container">
                    <div id="downloadBox" class="is-selected">
                        <div v-if="graph" class="visible-md-block visible-lg-block visible-xl-block">
                            <LineChart :data="{
                             datasets: [
                                  {
                                      label: graph.keyword,
                                      borderColor: '#2E5CE5',
                                      borderWidth: 2.8,
                                      tension: 0.2,
                                      fill: false,
                                      data: graph.graph
                                  }
                              ]
                        }" :options="chartDataModal.options"  style="display: block;" />
                        </div>
                        <div v-if="graph" class="visible-xs-block visible-sm-block">
                            <LineChart :data="{
                             datasets: [
                                  {
                                      label: graph.keyword,
                                      borderColor: '#2E5CE5',
                                      borderWidth: 1.5,
                                      tension: 0.2,
                                      fill: false,
                                      data: graph.graph
                                  }
                              ]
                        }" :options="chartDataModalMobile.options"  style="display: block;" />
                        </div>
                    </div>
                </div>
                <!-- cd-user-modal-container -->
            </div>
        </Teleport>
    </div>
</template>

<script>
    import PaginationUser from "../shared/components/PaginationUser.vue";
    import {datetimeMixin} from "../shared/mixins/datetime.mixin.js";
    import { Line as LineChart } from 'vue-chartjs'
    import {   Chart as ChartJS,
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend } from 'chart.js'
    import DisplayKeywordSearches from "@/components/DisplayKeywordSearches.vue";

    ChartJS.register(  CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend)

    let config = {
        xLabel: false,
        yLabel: false,
        label: 'Keyword - Updated on 2023-11-12'
    };


    export default {
        name: "Keywords",
        mixins:[datetimeMixin],
        emits: ['download', 'paginate'],
        props: {
            keywords: {required: true},
            isAuthenticated: {required: true, default:true},
            isFree: {required: true, default:false},
            isGwCount: {default:false},
            isGwCountExceeded: {default:false},
            download: {default:false},
        },
        components: {
            DisplayKeywordSearches,
            PaginationUser, LineChart
        },
        computed: {
            paginateTitle(){
                let pagetitle = "";

                if(! this.isAuthenticated)
                {
                    pagetitle = "Found " + Math.floor((Math.random() * 60000) + 50000) + " records" ;
                }
                else
                {
                    pagetitle = "Found " + (this.keywords?.total || 0) + " records - Displaying " + (this.keywords?.from || 0 )+ " to " + (this.keywords?.to || 0);
                }

                return pagetitle
            }
        },
        data(){
          return {
              countryGroup: window.__st.data.country_groups,
              routes: window.__st.routes,
              chartData: {
                  options: {

                      animation: false,
                      responsive: true,
                      maintainAspectRatio: false,

                      plugins: {
                          tooltip: {
                              callbacks: {
                                  label: function(context) {
                                      return context.parsed.y;
                                  }
                              }
                          },
                          legend: {
                              display: false,
                          }
                      },

                      elements: {
                          point: {
                              radius: 0,
                              hoverRadius: 5,
                          }
                      },
                      layout: {
                          padding: 0
                      },
                      scales: {
                          x: {
                              border: {
                                  display: false
                              },
                              ticks: {
                                  display: config.xLabel,
                                  align: 'start',
                                  maxRotation: 0,
                                  minRotation: 0,
                                  //display: false //this will remove only the label
                                  callback: function(val, index) {
                                      // Hide every 2nd tick label
                                      return index % 3 === 0 ? this.getLabelForValue(val) : '';
                                  },
                              },
                              grid: {
                                  display: config.xLabel
                              },
                          },
                          y: {
                              border: {
                                  display: false
                              },
                              ticks: {
                                  display: config.yLabel,
                              },
                              grid: {
                                  display: config.xLabel
                              },
                          }
                      }
                  }
              },
              chartDataModal: {
                  options: {
                      animation: false,
                      responsive: true,
                      plugins: {
                          tooltip: {
                              callbacks: {
                                  label: function(context) {
                                      return context.parsed.y;
                                  }
                              }
                          },
                          legend: {
                              display: true,
                          }
                      },

                      elements: {
                          point: {
                              radius: 0.1,
                              hoverRadius: 8,
                          }
                      },
                      layout: {
                          padding: 30
                      },
                      scales: {
                          x: {
                              border: {
                                  display: false
                              },
                              ticks: {
                                  display: true,
                                  align: 'start',
                                  maxRotation: 0,
                                  minRotation: 0,
                                  //display: false //this will remove only the label
                                  callback: function(val, index) {
                                      // Hide every 2nd tick label
                                      return index % 3 === 0 ? this.getLabelForValue(val) : '';
                                  },
                              },
                              grid: {
                                  display: false
                              },
                          },
                          y: {
                              border: {
                                  display: false
                              },
                              ticks: {
                                  display:true,
                              },
                              grid: {
                                  display: true
                              },
                          }
                      }
                  }
              },
              chartDataModalMobile: {
                  options: {
                      responsive: true,
                      plugins: {
                          tooltip: {
                              callbacks: {
                                  label: function(context) {
                                      return context.parsed.y;
                                  }
                              }
                          },
                          legend: {
                              display: true,
                          }
                      },

                      elements: {
                          point: {
                              radius: 0.1,
                              hoverRadius: 8,
                          }
                      },
                      layout: {
                          padding: 10
                      },
                      scales: {
                          x: {
                              border: {
                                  display: false
                              },
                              ticks: {
                                  display: true,
                                  align: 'start',
                                  maxRotation: 0,
                                  minRotation: 0,
                                  //display: false //this will remove only the label
                                  callback: function(val, index) {
                                      // Hide every 2nd tick label
                                      return index % 3 === 0 ? this.getLabelForValue(val) : '';
                                  },
                              },
                              grid: {
                                  display: false
                              },
                          },
                          y: {
                              border: {
                                  display: false
                              },
                              ticks: {
                                  display:true,
                              },
                              grid: {
                                  display: true
                              },
                          }
                      }
                  }
              },
              graph: null,
          }
        },
        methods:{

            fetch(value){
                this.$emit("paginate" , value)
            },

            ratingBadgeColor(rating) {

                if (rating < 1000)
                {
                    return "red";
                }
                else if (rating > 1000 && rating < 10000)
                {
                    return  "green";
                }
                return  "purple"
            },

            fetchGoogleWebCount() {

            },

            showGraph(keyword) {
                $("#graphModal").removeClass("is-visible");
                this.graph = keyword;
                $("#graphModal").addClass("is-visible");
            }
        }

    }
</script>

<style scoped>

    .btnTrendPercentage {
        border: 1px solid green;
        font-weight: 800;
        padding: 5px;
        margin-right: 4px !important;
        box-shadow: 1px 2px 1px  green;
    }

    .btnTrendLink {
        border: 1px solid #3b7fd9;
        padding: 5px;
        /**font-size: 9px !important;**/
        font-weight: 600;
        color: black;
        box-shadow: 1px 2px 1px  #3b7fd9;
    }

    .cd-user-modal-container {
        max-width: 65% !important;
    }

    @media only screen and (max-width: 600px) {
        .cd-user-modal-container {
            max-width: 95% !important;
        }
    }

    #keywordTableResponsive{
        max-height: 700px;
        overflow: auto;
    }

    .tblFixed thead tr:nth-child(1) th{
        background: white;
        position: sticky;
        top: 0;
        /*border: 1px solid white;*/
        z-index: 10;
    }

    .small.badge{
        font-size: 64%;
    }
    .scrollBarStyle::-webkit-scrollbar-track
    {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        border-radius: 10px;
        background-color: #F5F5F5;
    }

    .scrollBarStyle::-webkit-scrollbar
    {
        width: 10px;
        height: 10px;
        background-color: #F5F5F5;
    }

    .scrollBarStyle::-webkit-scrollbar-thumb
    {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: #555;
    }

    .blurry-text {
        color: transparent;
        text-shadow: 0 0 5px rgba(0,0,0,0.7);
    }

    .cd-user-modal-container {
        top: 50% !important;
        transform: translateY(-50%) !important;
        margin: 0 auto !important;
    }

    @media only screen and (max-width: 600px) {
        .cd-user-modal-container {
            top: 30% !important;
            transform: translateY(-30%) !important;
            margin: 0 auto !important;
        }

    }

</style>
